export default class Pax {
	constructor(name=null, email=null, phone=null, country={id:null}) {
		this.name = name;
		this.email = email;
		this.phone = phone;
		this.country = country;
	}
}



// WEBPACK FOOTER //
// ./src/model/Pax.js